class PatipelloSticky extends HTMLElement {
  connectedCallback() {
    this.formSelector = this.dataset.formSelector || 'product-form form';
    this.mainButton = document.querySelector(`${this.formSelector} [name="add"]`);
    this.button = this.querySelector('button');
    if (!this.mainButton || !this.button) return;
    this.button.addEventListener('click', () => this.mainButton.click());
    this.observer = new IntersectionObserver(([entry]) => this.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0.05 });
    this.observer.observe(this.mainButton);
    document.addEventListener('variant:change', () => this.sync());
    this.sync();
  }
  sync() {
    const price = document.querySelector('[id^="price-"] .price-item--regular, [id^="price-"] .price-item--sale');
    const target = this.querySelector('[data-sticky-price]');
    if (price && target) target.textContent = price.textContent.trim();
    this.button.disabled = this.mainButton?.disabled || false;
  }
}
if (!customElements.get('patipello-sticky')) customElements.define('patipello-sticky', PatipelloSticky);

document.addEventListener('click', (event) => {
  const link = event.target.closest('.patipello-button[href^="#"]');
  if (!link) return;
  const target = document.querySelector(link.getAttribute('href')) || document.querySelector('product-form');
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
});
